import React from "react";
import Sidebar from "react-sidebar";
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import Row from 'react-bootstrap/Form'
import ControlledTabs from './ControlledTabs.js'
import SettingsElement from './SettingsElement.js'
import store from "./store/index";
import { updateTimeSettings } from "./actions/index";
import { updateT0Settings } from "./actions/index";
import TimePicker from 'rc-time-picker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import date from "../node_modules/date-and-time"
import momentz from 'moment-timezone';
import CheckBox from './checkBoxComponent.js'
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import TimeSetter from './timeSetter.js'
import TimeSetterT0 from './timeSetter_t0.js'
import TimeSetterLatestOdds from './TimeSetterLatestOdds.js'
import  { Redirect } from 'react-router-dom'
import { Auth } from "aws-amplify";
import {STEAMER_MIN_PRICE} from "./constants/action-types";
import {STEAMER_MAX_PRICE} from "./constants/action-types";
import {DRIFTER_MIN_PRICE} from "./constants/action-types";
import {DRIFTER_MAX_PRICE} from "./constants/action-types";
import {MIN_VOLUME} from "./constants/action-types";
import {updateLocalTimeOffSetToGmt} from "./actions/index";
import {updateLocalTimeZone} from "./actions/index";


const showSecond = false;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

const inlineBlock = {
  display:'inline-block',
  width:'50%',
  color:'white',
}

const textColor1 = {
  color: 'green',

}

const style34 = {
  width:'300px',
  margin: '0 auto'
}
const format = 'hh:mm';

const ttt23={
  textAlign: 'center'
}

function minutesToHHMM(mins) {
  if(mins<0){
    return '00:00'
  }
let h = Math.floor(mins / 60);
let m = mins % 60;
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return `${h}:${m}`;
}


const alignCenter2={
  color: 'white',
  align: 'center',
  fontWeight: 'bold',
  margin: '0 auto'
}

const margin23={
  height: '50px',
  background: 'black'
}

const margin24={
  //marginTop: '20px',
  //marginBottom: '20px',
  bottom: '0',
  background: 'black'
}

const sideBarStyle = {
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
  },
  sidebar: {
    zIndex: 2,
    position: "absolute",
    top: 0,
    bottom: 0,
    transition: "left transform .3s ease-out",
    WebkitTransition: "-webkit-transform .3s ease-out",
    willChange: "transform",
    overflowY: "auto",
    background: "gray",
    width:"400px",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    transition: "left .3s ease-out, right .3s ease-out"
  },
  overlay: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: "hidden",
    transition: "opacity .3s ease-out, visibility .3s ease-out",
    backgroundColor: "rgba(0,0,0,.3)"
  },
  dragHandle: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    bottom: 0
  }
};

const timeArray = {
  t1: "03:30",
  t2: "06:45",
  t3: "07:00",
  t4: "34:30",
  t5: "02:00",
  t6: "03:00"
}

const btnMargin = {
  'margin-top': '10px',
}

class AppSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      isAuthenticated: false
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  getTimeDiffInMins(timeDiff){
    var hours =parseInt(timeDiff.substring(0,2))
    var mints =parseInt(timeDiff.substring(3,5))

    return (hours*60+mints)

  }

  convertMinutesToLocalTimeZone = num => {
    let sign = "+";
    if (num < 0) sign = "-"
    num = Math.abs(num);
    const hours = Math.floor(num / 60);
    const minutes = num % 60;
    return "GMT" + sign + (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes);
  }

  componentDidMount(){
    const offset = new Date().getTimezoneOffset() * -1;
    const timezone = this.convertMinutesToLocalTimeZone(offset);
    console.log("timezone offset: " + offset + ", timezone: " + timezone);
    store.dispatch(updateLocalTimeOffSetToGmt(offset));
    store.dispatch(updateLocalTimeZone(timezone));
  }

  handleSubmit(event) {
    store.dispatch( updateTimeSettings(timeArray))
    event.preventDefault();
  }

  handleChange(value,event) {
  }

  renderRedirect = () => {
     if (!this.props.isAuthenticated) {
       return <Redirect to='/login' />
     }
   }

   handleSubmit = async event =>{
     try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.updateUserAttributes(user, {
      "custom:gh:t1": store.getState().timeSettings.t1,
      "custom:gh:t2": store.getState().timeSettings.t2,
      "custom:gh:t3": store.getState().timeSettings.t3,
      "custom:gh:t4": store.getState().timeSettings.t4,
      "custom:gh:t5": store.getState().timeSettings.t5,
      "custom:gh:t6": store.getState().timeSettings.t6,
      "custom:gh:t0": store.getState().timeSettings.t0 +
       "|" + store.getState().latestOddsSettings.commision +
       "|" + store.getState().latestOddsSettings.backStake +
       "|" + store.getState().latestOddsSettings.layStake
       ,
      "custom:gh:exact_t1":store.getState().exactTimeSettings.t1,
      "custom:gh:exact_t2":store.getState().exactTimeSettings.t2,
      "custom:gh:exact_t3":store.getState().exactTimeSettings.t3,
      "custom:gh:exact_t4":store.getState().exactTimeSettings.t4,
      "custom:gh:exact_t5":store.getState().exactTimeSettings.t5,
      "custom:gh:exact_t6":store.getState().exactTimeSettings.t6,
      "custom:gh:exact_t0":store.getState().exactTimeSettings.t0,
      
      "custom:gh:t0_type":store.getState().isExactTimeSelected.t0 + "|" + store.getState().isExactTimeSelected.t1 + "|" + store.getState().isExactTimeSelected.t2 + "|" + store.getState().isExactTimeSelected.t3 + "|" + store.getState().isExactTimeSelected.t4 + "|" + store.getState().isExactTimeSelected.t5 + "|" + store.getState().isExactTimeSelected.t6,
      "custom:gh:t1_type": store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE + "|" + store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE + "|" + store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE + "|" + store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE,
      "custom:gh:t2_type": store.getState().StearmerDrifterSettings.MIN_VOLUME + "|" + store.getState().filteredCountryList.toString() + "|" + store.getState().latestOddsSettings.tickUntilActualStart + "|"+ store.getState().latestOddsSettings.noOfSeconds

    /*
      "custom:gh:t4_type":store.getState().isExactTimeSelected.t4,
      "custom:gh:t5_type":store.getState().isExactTimeSelected.t5,
      "custom:gh:t6_type":store.getState().isExactTimeSelected.t6,
      "custom:gh:steamer_min_price":store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE,
      "custom:gh:steamer_max_price":store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE,
      "custom:gh:drifter_min_price":store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE,
      "custom:gh:drifter_max_price":store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE,
      "custom:gh:min_volume":store.getState().StearmerDrifterSettings.MIN_VOLUME,
      "custom:gh:filteredCountryList": store.getState().filteredCountryList.toString(),
      "custom:gh:latestodds:mode":store.getState().latestOddsSettings.tickUntilActualStart,
      "custom:gh:latestodds:seconds":store.getState().latestOddsSettings.noOfSeconds
      */  
      });

      alert("Successfully Updated");
    } catch (e) {
      alert(e);
      console.log(e);
    }
   }

  handleCheckboxChange = event =>
      this.setState({ checked: event.target.checked })

  render() {
    var stateVal = { checked: false }

    store.getState().allCountryList.map(country => console.log("All Selected country ::"+country))



    //console.log("hgjhnkjh kjk : "+store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE)
    return (
      <Sidebar
        sidebar={
          <div>
            {this.renderRedirect()}
          <div style={margin23} className="navbar navbar-dark bg-dark">
          <p style={alignCenter2}>Country Configuration</p>
          </div>
          <div>
            {Object.keys(store.getState().allCountryList2).map(countryItem =>
              <div key={countryItem} style={style34}><CheckBox country={store.getState().allCountryList2[countryItem]} /></div>
            )}
          </div>
          <div style={margin23} className="navbar navbar-dark bg-dark">
          <p style={alignCenter2}>Display Timezone - {store.getState().localTimeZone}</p>
          </div>
          <div className="formMargin">
          <Form  onSubmit={this.handleSubmit}>
          <TimeSetterLatestOdds />
          <hr/>
          <TimeSetter timeDiff={store.getState().timeSettings.t1} label="T1"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t2} label="T2"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t3} label="T3"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t4} label="T4"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t5} label="T5"/>
          <TimeSetter timeDiff={store.getState().timeSettings.t6} label="T6"/>
          <hr/>
          <div className="wrapper1">
          <Button variant="secondary" block onClick={this.handleSubmit}>
          Submit
          </Button>
            </div>
        </Form>
        </div>
        </div>
        }
        open={this.state.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        styles={sideBarStyle}
      >
        <ControlledTabs openSideBar={this.onSetSidebarOpen} user={this.props.userName} userHasAuthenticated={this.props.userHasAuthenticated}/>


      </Sidebar>
    );
  }
}

export default AppSideBar;
